import React from 'react';
import { PageHeader } from '../components/ui/PageHeader';
import { SectionHeading } from '../components/ui/SectionHeading';
import { Card, CardContent } from '../components/ui/Card';
import { AlertTriangle, Clock, Mail, CheckCircle2 } from 'lucide-react';
import { CFA_INFO } from '../data/constants';
export function Reclamations() {
  return <div className="flex flex-col w-full" data-id="element-2109" data-mp="2esuo4apxnnys">
      <PageHeader title="Gestion des Réclamations" subtitle="Votre satisfaction est notre priorité. Nous sommes à votre écoute pour traiter toute insatisfaction." data-id="element-2110" data-mp="3cei8fx946fty" />

      <div className="py-16 md:py-24 bg-white relative overflow-hidden" data-id="element-2111" data-mp="32gly37o03oww">
        <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-brand-orange rounded-full blur-[100px] opacity-10 pointer-events-none" data-id="element-2112" data-mp="32ip06q2fh8hz" />
        <div className="container max-w-5xl mx-auto relative z-10" data-id="element-2113" data-mp="1r1yowsj5dqhi">
          <section className="text-center mb-20" data-id="element-2114" data-mp="1qz2rd5b7p3tl">
            <p className="text-xl md:text-2xl text-muted-foreground leading-relaxed max-w-3xl mx-auto font-medium" data-id="element-2115" data-mp="1m1aya7ytzbnt">
              Dans le cadre de notre démarche d'amélioration continue, Zillenium
              Alternance met à disposition de l'ensemble de ses parties
              prenantes (apprentis, entreprises, financeurs, partenaires) une
              procédure de gestion des réclamations claire et transparente.
            </p>
          </section>

          <div className="grid md:grid-cols-2 gap-10 mb-20" data-id="element-2116" data-mp="1omli4sk6ihlp">
            <Card className="border-none shadow-xl bg-white hover:-translate-y-2 transition-transform duration-300 group" data-id="element-2117" data-mp="1ol0i4nf3i6gg">
              <div className="h-2 w-full bg-primary" data-id="element-2118" data-mp="1tf4ujm74r6ox" />
              <CardContent className="p-8 md:p-10" data-id="element-2119" data-mp="1epguspelkg3b">
                <h3 className="text-2xl font-extrabold font-heading text-primary-dark mb-8 flex items-center gap-4" data-id="element-2120" data-mp="1jni9yz8wjv9i">
                  <div className="w-12 h-12 rounded-xl bg-lavande flex items-center justify-center group-hover:scale-110 transition-transform" data-id="element-2121" data-mp="15n7ibtzrqcna">
                    <AlertTriangle className="w-6 h-6 text-primary animate-soft-pulse" data-id="element-2122" data-mp="19osz3qffbb2r" />
                  </div>
                  Motifs de réclamation possibles
                </h3>
                <ul className="space-y-5" data-id="element-2123" data-mp="37khom2k9ko9s">
                  <li className="flex items-start gap-4" data-id="element-2124" data-mp="37jgcdurihvqh">
                    <div className="w-2 h-2 rounded-full bg-brand-orange mt-2.5 shrink-0" data-id="element-2125" data-mp="32mycp9b1gnl0"></div>
                    <span className="text-muted-foreground leading-relaxed" data-id="element-2126" data-mp="2xoen8yx8ktnw">
                      <strong className="text-primary-dark font-bold" data-id="element-2127" data-mp="3vb3wntu9q8js">
                        Pédagogique :
                      </strong>{' '}
                      contenu de la formation, méthodes, évaluation.
                    </span>
                  </li>
                  <li className="flex items-start gap-4" data-id="element-2128" data-mp="3leitle1t77il">
                    <div className="w-2 h-2 rounded-full bg-brand-orange mt-2.5 shrink-0" data-id="element-2129" data-mp="3hab1d6w579fm"></div>
                    <span className="text-muted-foreground leading-relaxed" data-id="element-2130" data-mp="29yalyy7it602">
                      <strong className="text-primary-dark font-bold" data-id="element-2131" data-mp="25vo0rg5cujbu">
                        Administratif :
                      </strong>{' '}
                      inscription, contrat, facturation.
                    </span>
                  </li>
                  <li className="flex items-start gap-4" data-id="element-2132" data-mp="pddxlcmlxcjb">
                    <div className="w-2 h-2 rounded-full bg-brand-orange mt-2.5 shrink-0" data-id="element-2133" data-mp="udicwzbs417y"></div>
                    <span className="text-muted-foreground leading-relaxed" data-id="element-2134" data-mp="z6bitqizhflm">
                      <strong className="text-primary-dark font-bold" data-id="element-2135" data-mp="144w84uwp6eva">
                        Organisationnel :
                      </strong>{' '}
                      planning, locaux, matériel.
                    </span>
                  </li>
                  <li className="flex items-start gap-4" data-id="element-2136" data-mp="1d5kq20p7ozdg">
                    <div className="w-2 h-2 rounded-full bg-brand-orange mt-2.5 shrink-0" data-id="element-2137" data-mp="1i4nqf7u8yhf3"></div>
                    <span className="text-muted-foreground leading-relaxed" data-id="element-2138" data-mp="3ewxp494i0d1l">
                      <strong className="text-primary-dark font-bold" data-id="element-2139" data-mp="3jvit8jmvfgvb">
                        Relation entreprise :
                      </strong>{' '}
                      suivi en entreprise, missions.
                    </span>
                  </li>
                  <li className="flex items-start gap-4" data-id="element-2140" data-mp="2jlg4s8ozfha6">
                    <div className="w-2 h-2 rounded-full bg-brand-orange mt-2.5 shrink-0" data-id="element-2141" data-mp="2yj8jiympg1nb"></div>
                    <span className="text-muted-foreground leading-relaxed" data-id="element-2142" data-mp="2tkouuqgq8br9">
                      <strong className="text-primary-dark font-bold" data-id="element-2143" data-mp="2tiks4bukdisk">
                        Accessibilité :
                      </strong>{' '}
                      accueil PSH, aménagements.
                    </span>
                  </li>
                </ul>
              </CardContent>
            </Card>

            <div className="space-y-10" data-id="element-2144" data-mp="2atxo7wo4izgk">
              <Card className="bg-primary-dark text-white border-none shadow-xl hover:-translate-y-2 transition-transform duration-300 group" data-id="element-2145" data-mp="2asw8vg02rqt1">
                <div className="h-2 w-full bg-primary-accent" data-id="element-2146" data-mp="1n20d67si0bgi" />
                <CardContent className="p-8 md:p-10" data-id="element-2147" data-mp="1i4gv0wsojeja">
                  <h3 className="text-2xl font-extrabold font-heading mb-6 flex items-center gap-4" data-id="element-2148" data-mp="3tsvimbqbpn3s">
                    <div className="w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center group-hover:scale-110 transition-transform" data-id="element-2149" data-mp="2do85ey9j0w8">
                      <Mail className="w-6 h-6 text-lavande animate-soft-float" data-id="element-2150" data-mp="3jw0oe51328vb" />
                    </div>
                    Comment nous contacter ?
                  </h3>
                  <p className="text-lavande mb-6 leading-relaxed text-lg" data-id="element-2151" data-mp="geqt1odiu55k">
                    Toute réclamation doit être formulée par écrit et envoyée à
                    l'adresse email suivante :
                  </p>
                  <a href={`mailto:${CFA_INFO.email}`} className="text-xl font-bold text-brand-orange hover:text-white transition-colors underline underline-offset-4" data-id="element-2152" data-mp="7chn7bt76zyi">
                    {CFA_INFO.email}
                  </a>
                  <p className="text-sm text-lavande/70 mt-6 leading-relaxed" data-id="element-2153" data-mp="2w5mra03n5jtv">
                    Merci de préciser "Réclamation" dans l'objet de votre email
                    et de détailler au maximum le motif de votre insatisfaction.
                  </p>
                </CardContent>
              </Card>

              <Card className="border-none shadow-lg bg-white hover:-translate-y-1 transition-transform duration-300 group" data-id="element-2154" data-mp="suqfdw2jcjbt">
                <CardContent className="p-8" data-id="element-2155" data-mp="nvduvhz4zoce">
                  <h3 className="font-extrabold font-heading text-xl text-primary-dark mb-6 flex items-center gap-4" data-id="element-2156" data-mp="jwo9b23y30ho">
                    <div className="w-10 h-10 rounded-lg bg-lavande flex items-center justify-center group-hover:scale-110 transition-transform" data-id="element-2157" data-mp="euyy9mgq2mtl">
                      <Clock className="w-5 h-5 text-brand-orange animate-soft-pulse" data-id="element-2158" data-mp="4ym4kol6g8yu" />
                    </div>
                    Délais de traitement
                  </h3>
                  <div className="space-y-4 text-base" data-id="element-2159" data-mp="249dqwhuv2tud">
                    <div className="flex justify-between items-center pb-4 border-b border-slate-100" data-id="element-2160" data-mp="1zdge2lit45mc">
                      <span className="text-muted-foreground font-medium" data-id="element-2161" data-mp="27smdo3647b1a">
                        Accusé de réception
                      </span>
                      <span className="font-bold text-primary-dark" data-id="element-2162" data-mp="2glpnm1hjx5r6">
                        Sous 48h ouvrées
                      </span>
                    </div>
                    <div className="flex justify-between items-center" data-id="element-2163" data-mp="2lkaq67ka01is">
                      <span className="text-muted-foreground font-medium" data-id="element-2164" data-mp="1ovbc2bx0g5io">
                        Réponse et plan d'action
                      </span>
                      <span className="font-bold text-primary-dark" data-id="element-2165" data-mp="1sxyboyzxauqf">
                        Sous 10 jours ouvrés
                      </span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>

          <div className="text-center bg-muted p-10 md:p-12 rounded-3xl border-none shadow-sm" data-id="element-2166" data-mp="399v76kwvcopf">
            <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-6 shadow-sm" data-id="element-2167" data-mp="3e7wslchrp042">
              <CheckCircle2 className="w-10 h-10 text-primary animate-soft-bounce" data-id="element-2168" data-mp="361py430kmmc" />
            </div>
            <p className="text-xl font-medium text-primary-dark leading-relaxed max-w-2xl mx-auto" data-id="element-2169" data-mp="3v9u8949xluwo">
              Chaque réclamation est analysée par notre direction et fait
              l'objet d'une action corrective dans le cadre de notre démarche
              d'amélioration continue.
            </p>
          </div>
        </div>
      </div>
    </div>;
}